import {Component, OnInit} from '@angular/core';
import {RxComponent} from 'app/core/components/common/rx.component';
import {ActivatedRoute, Router} from '@angular/router';
import {VenueDetails} from '../add/venue-add-details.model';
import {FormService} from 'app/shared/components/form/form.service';
import {NotificationService} from 'app/core/services/notification.service';
import {ConfigService} from 'app/core/services/config.service';
import {SimpleInfoComponent} from 'app/shared/components/modal/simple-info.component';
import {SmartModalService} from 'app/core/services/smart-modal.service';
import {Observable} from 'rxjs/Observable';
import {VenuesService} from '../../venues.service';

@Component({
    selector: 'itpx-venue-edit',
    templateUrl: './venue-edit.component.html',
    styleUrls: ['./venue-edit.component.css', '../base.css']
})
export class VenueEditComponent extends RxComponent implements OnInit {

    private id: string;
    private details: VenueDetails = new VenueDetails();
    private editUrl: string;
    private guidances = {
        'name': 'venues.fields.name.guidance',
        'room': 'venues.fields.room.guidance',
        'address': 'venues.fields.address.guidance',
        'city': 'venues.fields.city.guidance',
        'state': 'venues.fields.state.guidance',
        'province': 'venues.fields.province.guidance',
        'country': 'venues.fields.country.guidance',
        'postalCode': 'venues.fields.postalCode.guidance',
    };

    constructor(private service: VenuesService,
                private router: Router,
                private route: ActivatedRoute,
                private configService: ConfigService,
                private formService: FormService,
                private modalService: SmartModalService,
                private notificationService: NotificationService) {
        super();
    }

    ngOnInit() {
        this.editUrl = this.configService.get('server').url + this.configService.get('endpoints').solar.address.editall.api+'?editAll=true';
        this.route.params.subscribe(params => {
            this.id = params['id'];
            this.service.getVenueDetails(this.id).subscribe(response => {
                this.details = response['data'];
            });
        });
    }

    checkIfVenueIsInUse() {
        if (this.details.numberOfClasses > 0) {
            this.openModal('venues.messages.already-in-use', 'Edit venue', false).subscribe(
                result => {
                    if(result)
                        this.save();
                }
            );
        } else {
            this.save();
        }
    }

    private openModal(text: string, title: string, danger: boolean): Observable<any> {
        let result = this.modalService.open(SimpleInfoComponent, {text: text, btn: (danger ? 'btn-danger' : 'btn-warning'), btnYesText: 'Save'}, title)
            .mapTo(true)
            .catch(_ => Observable.of(false));

        return result;
    }

    onSubmit() {
        this.checkIfVenueIsInUse();
    }

    private save() {
        this.formService.save(this.details, this.editUrl)
            .subscribe(
                data => {
                    this.notificationService.success('Successfully updated the data', 'Success');
                    this.onSaveFinished(data);
                }
            );
    }

    private onSaveFinished(event) {
        this.router.navigate(['/organization/venues']);
    }

    ngOnDestroy() {
        this.modalService.close();
    }

    cancel() {
        this.router.navigate(['organization', 'venues']);
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/venues/components/edit/venue-edit.component.ts